import {
  Baby,
  CalendarCheck,
  ClipboardCheck,
  ClipboardList,
  Forward,
  Hourglass,
  MailOpen,
  Microscope,
  Radiation,
  SquareMenu,
} from "lucide-react";

const ICON_SIZE = 20;

export const menuItems = [
  { src: ClipboardCheck, label: "All Results", value: "all-results" },
  // Second by design. Maternity messages that reached no chart are the ones a
  // practice is least likely to go looking for, so they sit where they get seen.
  { src: Baby, label: "Maternity", value: "maternity" },
  // Third, beside the laboratory results it is the other half of: a result that came
  // back and a test that never did are the same question asked from opposite ends.
  {
    src: Hourglass,
    label: "Outstanding lab tests",
    value: "outstanding-lab-tests",
  },
  { src: Microscope, label: "Laboratory", value: "laboratory" },
  { src: Radiation, label: "Radiology", value: "radiology" },
  { src: CalendarCheck, label: "Appointment", value: "appointment" },
  {
    src: Forward,
    label: "Referral responses",
    value: "referral-responses",
  },
  { src: ClipboardList, label: "COOP / Discharges", value: "coop-discharges" },
  {
    src: MailOpen,
    label: "Postal correspondence",
    value: "postal-correspondence",
  },
  { src: SquareMenu, label: "Other", value: "other" },
];

/**
 * `counts` is keyed by tab value. A tab with nothing outstanding shows no number at
 * all rather than a zero — TabSwitcher renders the count only when it isn't null,
 * and "(0)" is noise on a row of eight tabs.
 */
export const getTabOptions = (counts = {}) =>
  menuItems.map((item) => {
    const Icon = item.src;
    const count = counts[item.value];

    return {
      value: item.value,
      label: item.label,
      icon: <Icon size={ICON_SIZE} strokeWidth={2} aria-hidden />,
      count: count > 0 ? count : null,
    };
  });
